import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
`

export const CodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${myPalette.aliceBlue.main};
  border-radius: 16px;
  padding: 24px 16px;
`

export const Description = styled.div`
  text-align: center;
  font-size: 16px;
  margin-bottom: 24px;
  font-weight: 400;
`
